<div class="container-fluid g-0" >
 <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
    <div class="container pt-3 pr-0 pl-0 pb-2">
        <div class="d-flex justify-content-between align-items-end w-100">
            <div>
                <div class="text-center">
                    <span style="font-size: xx-large;font-weight: 600;">Ma Box Orange</span>
                </div>
                <button type="button" class="btn btn-primary btn-lg"
                (click)="goDownloadApp()">
                    Télécharger l'application
                </button>
            </div>
            <div class="d-flex justify-content-end align-items-end">
                <img style="width: 51%;" src="assets/images/logos.svg">
            </div>
        </div>
    </div>
</nav>
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-4">
                <img src="assets/images/rectangle1.png" style="width: 100%;height: 100%;">
            </div>
            <div class=" col-md-12 col-lg-8">
                <div class="row">
                    <div class="col-md-12 pb-2">
                        <span style="font-size: xx-large;font-weight: 600;">
                            Qu'est ce que « Ma Box Orange » 
                        </span>
                    </div>
                    <div class="col-md-12">
                        <p style="font-weight: bold;">
                            « Ma Box Orange »  est une application mobile qui vous permet de gérer en toute
                            autonomie votre abonnement internet (FTTH pour le moment). Ci-dessous les principales
                            fonctions :
                        </p>
                    </div>
                </div>
                <div class="row row-cols-2 row-cols-lg-4 g-3 g-lg-3">
                    <div class="col">
                        <div class="p-2 border border-2 rounded-1 card-body">
                            <h6 class="card-title mb-1">Mes abonnements</h6>
                            <p class="card-text">
                                Ajoutez et géolocalisez tous vos abonnements à la Fibre d’Orange.
                            </p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="p-2 border border-2 rounded-1 card-body">
                            <h6 class="card-title mb-1">Mes commandes</h6>
                            <p class="card-text">Suivez l’évolution de votre installation partout où vous êtes et
                                recevez des notifications à chaque étape</p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="p-2 border border-2 rounded-1 card-body">
                            <h6 class="card-title mb-1">Mes notifications</h6>
                            <p class="card-text">
                                Vous recevrez des notifications et alertes sur
                                la vie de votre réseau: travaux programmés, dysfonctionnements, offres, etc.
                            </p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="p-2 border border-2 rounded-1 card-body">
                            <h6 class="card-title mb-1">J'ai besoin d'aide</h6>
                            <p class="card-text">
                                En cas de besoin, initiez avec facilité
                                votre réclamation et suivez en temps réel son avancement
                            </p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="p-2 border border-2 rounded-1 card-body">
                            <h6 class="card-title mb-1">Mes services</h6>
                            <p class="card-text">
                                Vous pouvez visualiser les infos sur votre abonnement et consulter
                                l’état des services auxquels vous avez souscrits
                            </p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="p-2 border border-2 rounded-1 card-body">
                            <h6 class="card-title mb-1">Mes Factures</h6>
                            <p class="card-text">
                                Suivez l’évolution de votre installation partout où
                                vous êtes et recevez des notifications à chaque étape
                            </p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="p-2 border border-2 rounded-1 card-body">
                            <h6 class="card-title mb-1">Ma LiveBox Fibre</h6>
                            <p class="card-text">
                                En cas de besoin, initiez avec facilité votre réclamation et
                                suivez en temps réel son avancement
                            </p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="p-2 border border-2 rounded-1 card-body">
                            <h6 class="card-title mb-1">Mon wifi</h6>
                            <p class="card-text">
                                Modifiez aisément à distance et à tout moment,
                                le nom de votre wifi ainsi que votre clé wifi .
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <hr style="margin: 30px 0 10px 0;">
                </div>
                <div class="col mb-3">
                    <span class="spanAcces" style="font-size: xx-large;font-weight: 600;">
                        Comment y avoir accès ?
                    </span>
                </div>
                <div class="col">
                    <div class="row gy-2">
                        <div class="col-md-6">
                            <button type="button" class="btn btn-light w-100" (click)="open(content)"
                                style="border-radius: 0;padding: 47px 11px">
                                <span style="font-weight: 600;" class="lib-btn"><img src="assets/images/shape1.svg" style="margin-right: 5px;"> 
                                    Créer votre compte</span>
                                <i class='bx bx-chevron-right bx-md' style="float: right;position: relative;top: 6px;"></i>
                            </button>
                        </div>
                        <div class="col-md-6">
                            <button type="button" class="btn btn-light w-100" (click)="openRattachement(contentRattachement)"
                                style="border-radius: 0;padding: 47px 11px">
                                <span style="font-weight: 600;" class="lib-btn">
                                    <img src="assets/images/shape2.svg" style="margin-right: 5px;"> 
                                     Rattacher votre abonnement fibre</span>
                                <i class='bx bx-chevron-right bx-md' style="float: right;position: relative;top: 6px;"></i>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<ng-template #content let-modal>
<nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
    <div class="container modal-header modal-compte parent-div">
        <h3 class="modal-title" id="modal-basic-title">Processus de création de compte</h3>
        <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button> -->
        <img src="assets/images/Groupe116.svg" alt="" (click)="modal.dismiss('Cross click')"
            style="cursor: pointer;height: 45px;">
    </div>
</nav>
    <div class="modal-body">
        <div class="container parent-div">
            <hr class="enfant-slide">
            <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-2 g-lg-4 creation-compte">
                <div class="col">
                    <div class="global-etape">
                        <div class="etape">
                            <span>1</span>
                        </div>
                    </div>
                    <div>
                         <img src="assets/images/Groupe66.png" class="imgApp">
                    </div>
                    <div class="mt-4 info-slide">
                        <ul>
                            <li>
                                Saisissez votre numéro 
                                mobile<br> puis Cliquez sur <img src="assets/images/Groupe61.png" 
                                style="width: 33px;position: relative;top: 4px;">
                            </li>
                        </ul>
                    </div>
                </div>  
                <div class="col">
                    <div class="global-etape">
                        <div class="etape">
                            <span>2</span>
                        </div>
                    </div>
                    <div>
                        <img src="assets/images/Groupe70.png"  class="imgApp">
                    </div>
                    <div class="mt-4 info-slide">
                        <ul>
                            <li>Vous recevrez par SMS un code OTP de 4 chiffres. </li>
                            <li>Votre smartphone détectera le 
                                message OTP. Veuillez cliquer sur <div class="autoriser"><span>Autoriser</span></div> pour 
                                renseigner automatiquement le code à 4 chiffres 
                                et le valider.
                            </li>
                            <li>
                                Si votre smartphone ne détecte pas le message OTP, veuillez renseigner
                                manuellement le code à 4 chiffre reçu par sms.
                            </li>
                          </ul>
                         
                    </div>
                </div>  
                <div class="col">
                    <div class="global-etape">
                        <div class="etape">
                            <span>3</span>
                        </div>
                    </div>
                    <div>
                        <img src="assets/images/Groupe86.png" class="imgApp">
                    </div>
                    <div class="mt-4 info-slide">
                        <ul>
                            <li>
                                L’application « Ma Box Orange » vous affiche un aperçu de ses fonctionnalités.
                            </li>
                            <li>
                                Veuillez swiper de la droite vers la gauche jusqu’à la fin.
                            </li>
                        </ul>
                    </div>
                </div>  
                <div class="col">
                    <div class="global-etape">
                        <div class="etape">
                            <span>4</span>
                        </div>
                    </div>
                    <div>
                        <img src="assets/images/Groupe125.png" class="imgApp">
                    </div>
                    <div class="mt-4 info-slide">
                        <ul>
                            <li>
                                Votre compte « Ma Box Orange » est ainsi créé.
                            </li>
                            <li>
                                Veuillez cliquer sur <img src="assets/images/Groupe130.png" style="width: 100px;">
                            </li>
                        </ul>
                    </div>
                </div>  
            </div>
        </div>
    </div>
</ng-template>
  
<ng-template #contentRattachement let-modal>
<nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
    <div class="container modal-header modal-rattachement parent-div">
        <h3 class="modal-title" id="modal-basic-title">Processus de Rattachement d’un abonnement Fibre.</h3>
        <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button> -->
        <img src="assets/images/Groupe116.svg" alt="" (click)="modal.dismiss('Cross click')"
            style="cursor: pointer;height: 45px;">
    </div>
</nav>
    <div class="modal-body rattacher">
        <div class="container parent-div">
            <hr class="enfant-slide">
            <div class="row row-cols-1 row-cols-md-2 row-cols-lg-5 g-2 g-lg-4 creation-compte">
                <div class="col">
                    <div class="global-etape">
                        <div class="etape">
                            <span>1</span>
                        </div>
                    </div>
                    <div>
                         <img src="assets/images/Groupe92.png" class="imgApp">
                    </div>
                    <div class="mt-4 info-slide">
                        <ul>
                            <li>
                                Cliquez sur <img src="assets/images/Groupe121.png" 
                                style="width: 59px;position: relative;top: -3px;"> <br>
                                 pour rattacher votre abonnement Fibre.
                            </li>
                        </ul>
                    </div>
                </div>  
                <div class="col">
                    <div class="global-etape">
                        <div class="etape">
                            <span>2</span>
                        </div>
                    </div>
                    <div>
                        <img src="assets/images/Groupe89.png"  class="imgApp">
                    </div>
                    <div class="mt-4 info-slide">
                        <ul>
                            <li>Renseignez votre numéro ou votre login fibre puis cliquez sur <img src="assets/images/Groupe107.png" 
                                style="width: 64px;"> <br>
                            </li>                          
                          </ul>
                         
                    </div>
                </div>  
                <div class="col">
                    <div class="global-etape">
                        <div class="etape">
                            <span>3</span>
                        </div>
                    </div>
                    <div>
                        <img src="assets/images/Groupe95.png" class="imgApp">
                    </div>
                    <div class="mt-4 info-slide">
                        <ul>
                            <li>
                                Vous recevrez par SMS un code OTP de 4 chiffres. 
                            </li>
                            <li>
                                Votre smartphone détectera le message OTP. Veuillez cliquer sur  <div class="autoriser"><span>Autoriser</span></div> 
                                pour renseigner automatiquement le code à 4 chiffres et le valider.
                            </li>
                            <li>
                                Si votre smartphone ne détecte pas le message OTP, veuillez renseigner 
                                manuellement le code à 4 chiffre reçu par sms.
                            </li>
                        </ul>
                    </div>
                </div>  
                <div class="col">
                    <div class="global-etape">
                        <div class="etape">
                            <span>4</span>
                        </div>
                    </div>
                    <div>
                        <img src="assets/images/Groupe98.png" class="imgApp">
                    </div>
                    <div class="mt-4 info-slide">
                        <ul>
                            <li>
                                Dans le champ « Adresse Abonnement », renseigner le nom que vous souhaitez 
                                pour la localisation de l’abonnement puis cliquez sur <img src="assets/images/Groupe115.png" 
                                style="width: 64px;"> <br>
                            </li>
                        </ul>
                    </div>
                </div>  
                <div class="col">
                    <div class="global-etape">
                        <div class="etape">
                            <span>5</span>
                        </div>
                    </div>
                    <div>
                        <img src="assets/images/Groupe101.png" class="imgApp">
                    </div>
                    <div class="mt-4 info-slide">
                        <ul>
                            <li>
                                Votre abonnement Fibre est maintenant rattaché à votre compte « Ma Box Orange »
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="container fermer">
            <button type="button" class="btn btn-light" id="fermer1"  (click)="fermer()">Fermer</button>
        </div> -->
    </div>
</ng-template>

